module.exports = __webpack_public_path__ + "static/articulo8-2eb9f12af9b0ee7bbb89446f33aec750.png";